"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 18.08V19h.92l5.12-5.12-.92-.92zm9.06-9.06-1.11 1.11.92.92 1.11-1.11z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m14.06 9.02.92.92-1.11 1.11 1.41 1.41 2.52-2.52-3.75-3.75-2.52 2.52 1.41 1.41zm6.65-1.98c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75zM2.81 2.81 1.39 4.22l7.32 7.32L3 17.25V21h3.75l5.71-5.71 7.32 7.32 1.41-1.41zM5.92 19H5v-.92l5.13-5.13.92.92z"
}, "1")], 'EditOffTwoTone');